<template>
  <el-dialog
    width="80%"
    :visible.sync="showStore"
    :before-close="closeStore"
    :append-to-body="true"
    title="优惠券关联店铺"
    destroy-on-close
  >
    <el-row :gutter="20" class="searchRow" type="flex" align="middle">
      <el-col :span="4">
        <el-input v-model="queryform.shop_name" clearable placeholder="店铺名称"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="handleButton(1)">搜 索</el-button>
        <el-button type="primary" @click="handleButton(2)">重 置</el-button>
      </el-col>
      <el-col :span="4">
        <p>当前{{list.length}}家店铺</p>
      </el-col>
    </el-row>
    <div class="waiceng">
      <div v-for="(item,index) in list" :key="index" class="mk">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="20">
            <div class="name">{{item.name}}</div>
            <div class="time">{{item.valid_start_date}}</div>
          </el-col>
          <el-col :span="4">
            <el-button
              class="xuanze"
              type="primary"
              plain
              size="mini"
              @click="commodity(item,index)"
            >确认选择</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="jvzhong">
            <div class="circle circle1"></div>
            <div class="amount">{{item.goodsCount}}</div>
            <div>商品总数</div>
          </el-col>
          <el-col :span="6" class="jvzhong">
            <div class="circle circle2"></div>
            <div class="amount">{{item.order_count}}</div>
            <div>订单总数</div>
          </el-col>
          <el-col :span="6" class="jvzhong">
            <div class="circle circle3"></div>
            <div class="amount">{{item.order_price}}</div>
            <div>订单交易额</div>
          </el-col>
          <el-col :span="6" class="jvzhong">
            <div class="circle circle4"></div>
            <div class="amount">{{item.order_pricepay}}</div>
            <div>店铺的总UV</div>
          </el-col>
        </el-row>
      </div>
      <!-- 分页 -->
      <pagination
        v-if="list.length>0"
        :total="total"
        :pageNum="queryform.page"
        :pageSize="queryform.page_size"
        @pageChange="pageChange"
      />
    </div>

    <Commodity
      :show="showCommodity"
      :commoditys="commoditys"
      :stores="stores"
      @close="closeCommodity"
    />
  </el-dialog>
</template>

<script>
import pagination from "@/components/pagination/index.vue";
import Commodity from "./couponSettingCommodity";
import { shopList } from "@/api/couponManagement/couponSetting";
export default {
  props: ["show", "stores"],
  components: {
    pagination,
    Commodity,
  },
  data() {
    return {
      showStore: false,
      showCommodity: false, //关联商品
      commoditys: "", //关联商品
      form: {
        name: "",
      },
      queryform: {
        shop_name: "",
        page_size: 10,
        page: 1,
      },
      total: 0,
      list: [],
      row: "",
    };
  },
  watch: {
    show() {
      Object.assign(this.$data, this.$options.data()); //重置data
      this.showStore = this.show;
      if (this.show == true) {
        this.getshopList();
      }
    },
  },
  methods: {
    closeStore() {
      this.$emit("close");
    },
    closeCommodity(row) {
      this.showCommodity = false; //关联商品
      if (row == 1) {
        this.$emit("close");
      }
      console.log(row, "--------------------");
    },
    handleButton(val) {
      switch (val) {
        case 1:
          this.getshopList();
          break;
        case 2:
          this.queryform.shop_name = "";
          this.getshopList();
          break;
        default:
          break;
      }
    },
    pageChange(page) {
      this.queryform.page_size = page._page_size;
      this.queryform.page = page._currentPage;
      this.getshopList();
    },
    commodity(row, index) {
      if (this.stores == 10) {
        this.row = row;
        this.$store.multipleSelection.push(row);
        this.closeStore();
      } else if (this.stores == 60) {
        this.showCommodity = true;
        this.commoditys = "";
      } else if (this.stores == 20) {
        this.showCommodity = true;
        this.commoditys = row.shop_id;
      }
    }, // 关联商品
    getshopList() {
      // console.log(localStorage.getItem("Beitoken"));
      let data = {
        shop_name: this.queryform.shop_name,
        page: this.queryform.page,
        page_size: this.queryform.page_size,
      };
      shopList(data).then((res) => {
        if (res.code == 1) {
          this.total = parseInt(res.data.count);
          this.list = res.data.shop_list;
          console.log(this.list, "res----------------------");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.mk {
  margin: 20px;
  height: 310px;
  background-color: #ffffff;
}
.jvzhong {
  text-align: center;
}
.circle {
  width: 95px;
  height: 95px;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 33px;
}
.circle1 {
  border: 15px solid #fb7369;
}
.circle2 {
  border: 15px solid #48eadc;
}
.circle3 {
  border: 15px solid #a46ded;
}
.circle4 {
  border: 15px solid #ffc066;
}
.name {
  margin-top: 31px;
  margin-left: 28px;

  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.xuanze {
  margin-top: 24px;
  margin-left: 85px;
}
.time {
  margin-left: 26px;
  margin-top: 10px;
  width: 225px;
  height: 12px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.amount {
  margin-top: 24px;
  margin-bottom: 10px;
}
.waiceng {
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #f0f0f0;
}
</style>
